export default function ({redirect}) {
    const isTermsAccepted = !!localStorage.getItem('termsAccepted')
      // If the user has not accepted T&C
      if (!isTermsAccepted) {
      redirect('/portal/find-company/' + localStorage.getItem('slug') + '/terms-and-conditions')
    }
}
